import exologAdmin from "@/exologAdmin";
import $$ from "jquery";
import overlay from "@/common/overlay";
import "./exolog-forms";
import { loadIconify } from "@/utils/iconHelper";

if (process.env.NODE_ENV !== "production") {
    console.info("-==development mode==-");
} else {
    //console.info('-==production mode==-');
}
let exologLoader = {
    async init() {
        // Load Iconify script early for icon support
        await loadIconify();

        exologAdmin.init();

        if ($$('meta[name="exologEditor"]').length) {
            await this.initExologEditor();
        }
    },
    async initExologEditor() {
        overlay.show("body");
        let exologEditor = (
            await import(
                /* webpackChunkName: "exolog-editor" */ "@/exologEditor"
            )
        ).default;

        // Enable enhanced UI features for all edit modes
        // Both ?exologEditor=yes and ?exologEditor=dev now use the enhanced UI
        const urlParams = new URLSearchParams(window.location.search);
        const editorMode = urlParams.get("exologEditor");

        if (editorMode === "yes" || editorMode === "dev") {
            console.info("✨ [EXOLOG EDITOR] Enhanced UI mode enabled");
            exologEditor.isDevelopmentMode = true;
        } else {
            exologEditor.isDevelopmentMode = true;
        }

        exologEditor.init();
    },
};

$$((_) => {
    exologLoader.init();
});
